import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
`
type Props = {
    /** 色 */
    color?: string
}

/**
 * SVGアイコンコンポーネント
 * カルーセルバナー用矢印（右）
 */
const CarouselArrowRightSvg = (props: Props): JSX.Element => (
  <Wrapper>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20.25" viewBox="0 0 15 20.25">
          <path id="パス_5251" data-name="パス 5251" d="M0,0,7.979,10.123,0,20.25H7.024L15,10.123,7.024,0Z" fill={props.color}/>
      </svg>
  </Wrapper>
)
export default CarouselArrowRightSvg
